import styled from 'styled-components'
import { Button } from '../../globalStyles'

export const BodyContainer = styled.div`
    text-align: center;
    font-size: 1.5rem;
    padding-bottom: 2rem;
`

export const BodyTitle = styled.p`
    text-align: center;
    font-size: 2rem;
`

export const BodyDesc = styled.p`

`

export const BodyForm = styled.div`

`

export const BodyFormButton = styled.button`
    display: inline;
    position: absolute;
    transform: translate(-48px, 1px)
`

export const BodyButton = styled.button`
    font-size: 1.5rem;  
    border: none;
    color: white;
    background-color: #4CAF50;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
`

export const BodyInput = styled.input`
    font-size: 1.5rem;  
    border: none;
    color: white;
    background-color: #4CAF50;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
`

export const BodyTextArea = styled.textarea`
    width: 20rem;
    font-size: 20px;
    height: 20rem;
    width: 50rem;
`
export const BodyTextAreaPreview = styled.textarea`
    width: 20rem;
    font-size: 20px;
    height: 10rem;
    width: 50rem;
`
export const BodyImage = styled.img`
    width: 50%;
    height: auto;
    box-sizing: border-box;
    font-size: 1rem;
`